export default {
  SET_ROUTE (state, route) {
    state.route = route
  },
  SET_DRAWER (state, drawer) {
    state.drawer = drawer
  },
  SET_ROLE (state, role) {
    state.role = role
  },
  SET_ALERT (state, alert) {
    state.alert = alert
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_DIALOG (state, dialog) {
    state.dialog = dialog
  },
  SET_LANG (state, lang) {
    state.lang = lang
  },
  SET_STATISTIC (state, statistic) {
    state.statistic = statistic
  },
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_WEBSITE (state, website) {
    state.website = website
  },
  SET_NEW_SUBSCRIBER_DIALOG (state, status) {
    state.newSubscriberDialog = status
  },
  SET_UPDATE_SUBSCRIBER_DIALOG (state, status) {
    state.updateSubscriberDialog = status
  },
  SET_SUBSCRIBER (state, subscriber) {
    state.subscriber = subscriber
  }
}
